/*
 * @Description:
 * @Author: xz
 * @Date: 2023-10-12 18:42:03
 * @LastEditTime: 2023-11-01 08:49:17
 * @LastEditors: xz
 */
import request from '../../utils/request'

export default {
    getRequest: function (url,data) {
        return request({
            url: url,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: 'get',
            params: data,
        })
    },
    postUrl: function (url,data) {
        return request({
            url: url,
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: 'POST',
            data: data
            // data: changeDataType(data),
        })
    },
    resoleRecorder: function (data) {
          return request({
              url: "/voice/resoleRecorder",
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              method: "POST",
              data: data
              // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              // data: changeDataType(data),
          })
      },
    getTreeGraph: function () {
          return request({
              url: "/knowledgeGraph/getTreeGraph",
              method: "GET",
          })
      },
  getDataByNodeName: function (data) {
          return request({
              url: "/knowledgeGraph/getDataByNodeName",
              method: "GET",
            params: data,

          })
      },
  searchDataByNodeId: function (data) {
          return request({
              url: "/knowledgeGraph/getDataByNodeId",
              method: "GET",
              params: data,
          })
      },
  getFloatData: function () {
          return request({
              url: "/floatData/getData",
              method: "GET",
          })
      },
    login: function (data) {
        return request({
            url: "/zaLogin/login",
            headers: {
            //   'Content-Type': 'multipart/form-data',
            },
            method: "POST",
            data: data
            // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

        })
    },
    sign: function (data) {
      return request({
          url: "/zaLogin/sign",
          method: "GET",
          params: data
      })
  },


  resetPassword: function (data) {
    return request({
      url: "/zaLogin/resetPassword",
      headers: {
        //   'Content-Type': 'multipart/form-data',
      },
      method: "POST",
      data: data
      // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },

    })
  },
  sevaPassword: function (data) {
    return request({
      url: "/zaLogin/sevaPassword",
      method: "POST",
      data: data,
      headers: { token: sessionStorage.getItem("token") },
    })
  },

    quitLogin: function () {
        return request({
            url: "/zaLogin/quitLogin",
            method: "Get",
            headers: { token: sessionStorage.getItem("token") },
        })
    },
    getUserNameByToken: function () {
        return request({
            url: "/zaLogin/getUserNameByToken",
            method: "Get",
            headers: { token: sessionStorage.getItem("token") },
        })
    },

  getUserByToken: function () {
    return request({
      url: "/zaLogin/getUserByToken",
      method: "Get",
      headers: { token: sessionStorage.getItem("token") },
    })
  },

  getUser: function () {
    return request({
      url: "/users/getuser",
      method: "Get",
    })
  },
  addtupuUser: function (data) {
    return request({
      url: "/users/addtupuUser",
      method: "POST",
      data: data
    })
  },

  updateUser: function (data) {
    return request({
      url: "/users/updateUser",
      method: "POST",
      data: data
    })
  },

  deleteUsertupu: function (data) {
    return request({
      url: '/users/deleteUsertupu',
      method: "POST",
      data: data
    })
  },

  userById: function (data) {
    return request({
      url: '/users/userById',
      method: "POST",
      data: data
    })
  },



  //获取组树
  getGroups() {
    return request({
      url: '/users/getGroups',
      method: 'get'
    })
  },

  //根据部门ID获取用户
  getUserByGroupId(data) {
    return request({
      url: '/users/getUserByGroupId',
      method: 'get',
      params: data
    })
  },

  //新增部门
  addGroups(data) {
    return request({
      url: '/users/addGroup',
      method: 'POST',
      data: data
    })
  },
  //修改部门
  updateGroup(data) {
    return request({
      url: '/users/updateGroup',
      method: 'POST',
      data: data
    })
  },

  //删除部门
  deleteGroup(params) {
    return request({
      url: '/users/deleteGroup',
      method: 'POST',
      params: params
    })
  },

}




// WEBPACK FOOTER //
// ./src/api/user.js